/**
 * @file index.tsx
 * @module app/modules/customer-category
 * @description Defines the route and page metadata for customer category management.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import CustomerCategory from "./customer-category";
import { PageLink, PageTitle } from "../../../_admin/layout/core";
const customerCategoryBreadCrumbs: Array<PageLink> = [
  {
    title: 'Customer Category',
    path: '/customer-category',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const CustomerCategoryPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        path="*"
        element={<Navigate to="/error/404" />}
      />
      <Route
        index
        element={
          <>
            <PageTitle>
              Customer Category
            </PageTitle>
            <CustomerCategory />
          </>
        }
      />
    </Route>
  </Routes>
);
export default CustomerCategoryPage;
